import { Box,Button,Flex,Select,InputGroup,
    InputLeftElement,Input, Heading, Text, 
    TableContainer,Table,Thead,Tbody,Th,Tr,Td } from "@chakra-ui/react";
  import { DateFilter, TopDisplay} from "../../../components";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState ,useEffect} from "react";
  import styled from "@emotion/styled";
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import apiCall from '../../../utils/apiCall';
  import { BsDownload as DownloadIcon } from "react-icons/bs";
  import { downloadApi } from "../../../api";
  import {useAtom,atom} from 'jotai'
  import { openAtom, notificationAtom, openNAtom } from "../../../context";
  import { Loader } from "../../../customs";
  import { TbReload as ReloadIcon } from "react-icons/tb";
  import ReactPaginate from 'react-paginate';
  import ReactSelect from "../../../components/Select";
  import appStore,{activePeriod} from '../../../store';
  
  const indexAtom = atom<number | null>(null);
  const list = [
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
  ]
  
  const HeadStyle={
    borderBottom:"1px solid var(--dark-green-color)",
    padding:'15px 5px',
  }
  const DataStyle = {
    padding:'5px 5px',
    thcolor:'var(--dark-green-color)'
  }
  
  
  const ROWSTYLE = styled.tr`
    & > td:last-of-type{
      width:50px;
      height:63px;
      & > div{
        display:none;
      }
    }
    &:hover > *{
      cursor: pointer;
      background-color:var(--table-highlight);
    } 
    & > td{
      width:140px;
    }
    &:hover > td:last-of-type{
      
      & > div{
        display: block;
      }
    }
    & > td > div.active{
      display: block;
    }
  `
  
  export default function StudentScoreRequest() {
  const [hide,set_hide] = useState<boolean>(true);
  const queryClient = useQueryClient();
  const [,set_open] = useAtom(openAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const aPeriod = appStore.get(activePeriod)?.Id;
  const [selected_examperiod,set_selected_examperiod] = useState<string>('');
   const [selected_examsubject,set_selected_examsubject] = useState<null | string>(null);
   const [selected_level,set_selected_level] = useState<null | string>(null);
   
   const {data:allExamPeriod} = useQuery(['exam-period'],{
        queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
        select(data){
         
          return data.data.Data;
        },
      });

      const {data:allLevel} = useQuery(['exemption'],{
        queryFn:async ()=> await apiCall().get(`/setup/GetAllExemption`),
        select(data){
          return data.data.Data;
        },
      })
    
       const {data:allExamSubject} = useQuery(['exam-subject'],{
        queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
        select(data){
          return data.data.Data;
        },
      })

    const {data:allStudentScore, isLoading} = useQuery(['student-score'+selected_examperiod],{
        queryFn:async()=>await apiCall().get(`exam/GetAllStudentScore?PageNumber=1&PageSize=100&ExamPeriodId=${selected_examperiod || ''}`),
        enabled:Boolean(selected_examperiod || ''),
        select(data){
          //console.log(data,'data')
        return data.data.reportItems;
        }
      });

    const [search,set_search] = useState('');
  
    const [filter_data,set_filter_data] = useState<any>(allStudentScore);
  
    
    const handleSearch = (e:any)=>{
      let val = e.target.value;
      set_search(val);
      if(val){
        let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
        if(new_data.length > 0)set_filter_data(new_data)
        else set_filter_data(allStudentScore)
      }
      else set_filter_data(allStudentScore)
    }

    const handleFilter=(str: string, p0: string) =>{
      if(str){
        set_selected_examperiod(str);
        let check:any = allStudentScore.filter((e:any) => e.ExamPeriod.toLowerCase() == str.toLowerCase());
        if(check && check?.length > 0){
          set_filter_data(check)
        }
      }
    }
    const handleFilter2=(str:string) =>{
      if(str){
        set_selected_examsubject(str);
        let check:any = allStudentScore.filter((e:any) => e.Subject == str);
        if(check && check?.length > 0){
          set_filter_data(check)
        }
      }
    }

    const handleFilter3 = (e: any, type: string) => {
    const value = type === 'level' ? Number(e || 0) : e;
  
    if (type === 'level') {
      if (value || !isNaN(value)) {
        let data = allStudentScore?.filter((eData: any) => {
          return eData.Level?.Id == value;
        });
  
        if (selected_examperiod) {
          data = data?.filter((eData: any) => eData.ExamPeriod == selected_examperiod);
        }
  
        set_filter_data(data && data.length > 0 ? data : allStudentScore);
        set_selected_level(value);
      }
    } else if (type === 'period') {
      if (value) {
        set_selected_examperiod(value); 
        let check: any = allStudentScore.filter((e: any) => e.ExamPeriod == value);
        set_filter_data(check && check?.length > 0 ? check : allStudentScore);
      }
    } else {
      
      let filteredData = allStudentScore;
  
      if (selected_examperiod) {
        filteredData = filteredData.filter(
          (e: any) => e.ExamPeriod == selected_examperiod
        );
      }
  
      set_filter_data(filteredData);
    }
  };

    const handleChangePeriod = (value:any) =>{
      //console.log(value,'value')
      if(value){
        set_selected_examperiod(value?.Id.toString());
        // let check:any = allStudentScore.filter((e:any) => e.ExamPeriod == value.ExamName);
        //set_filter_data(check)
      
      }
    }
  
  
    const itemsPerPage = 100;
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    const currentItems = filter_data?.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  
    const handlePageClick = (event:any) => {
      const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
      console.log(
        `User requested page number ${event.selected}, which is offset ${newOffset}`
      );
      setItemOffset(newOffset);
    };
  
    useEffect(()=>{
      if(aPeriod)set_selected_examperiod(aPeriod.toString());
    },[aPeriod])
  
    useEffect(()=>{
      //console.log(allStudentScore,'scores')
      set_filter_data(allStudentScore)
    },[allStudentScore])

    
    const {mutate:handleDownload,isLoading:isDownloading} = useMutation({
        mutationKey:[],
        mutationFn:async ()=> {
           
          const subject_id:any = allExamSubject.find((e:any) => e.Name === selected_examsubject )?.Id || ''; 
          const url = `/ExamReport/downloadStudentScoreReport?ExamPeriodId=${selected_examperiod}&ExamSubjectId=${subject_id}`,method = "POST",body = {},config = {},download = true;
          return await downloadApi(url,method,body,config,download)
    
        },
        onSuccess:async(data:any)=>{
          //initial the download 
          //console.log(data,'download data')
          let file = data;
         
          if(file){
            
            const url = window.URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "StudentsScore-report.xlsx");
            document.body.appendChild(link);
            link.click();
            //console.log(file,'data')
            set_notification({
              type:'success',
              message:data?.data?.Message || 'Upgraded Subject score downloaded Successfully'
            })
            set_Nopen(true);
          }
          else{
            set_notification({
              type:'error',
              message:'Oooops! Error Occured trying to download file'
            })
            set_Nopen(true);
          }
          
        },
        onError(error:any, variables, context) {
          set_notification({
            type:'error',
            message:error?.data?.Message || 'Error Occured'
          })
          set_Nopen(true);
        },
        onSettled:()=>{
          set_open(false);
        }
    
      } )
  
    return (
      <>
     {isLoading?<Loader />:
  
      <Box>
        <TopDisplay label="Upgrade Subject Score Report" button_array={[
          
            <Button  color="var(--white-color)" 
            bg="var(--dark-green-color)" leftIcon={<DownloadIcon/>}  
            
            onClick={()=>handleDownload()} disabled={isDownloading}
          >{isDownloading?" DownLoading....":'Download Subject Score Report'}</Button>,
           
          ]} />
          <Flex  gap="20px" wrap="wrap" mt="20px">
            <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
              <InputLeftElement pointerEvents='none'>
                <SearchIcon color='gray.300' />
              </InputLeftElement>
              <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
              <span style={{position:'absolute',zIndex:'1',
              right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
            </InputGroup>
            <ReactSelect 
              name="ExamName"
              onChange={handleChangePeriod}
              placeholder="Exam Period"
              options={allExamPeriod?.map((e:any)=> ({...e,['label']:e.ExamName,['value']:e.Id}))} />

               <Select placeholder="Level" width="140px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)"onChange={(e:any)=>handleFilter3(e.target.value,'level')} >
                {allLevel && allLevel.length > 0 ?
                    allLevel.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :''}
            </Select>
            {/* <Select placeholder='Exam Period' width="140px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)" onChange={(e:any)=>handleFilter(e.target.value)}
                  name="ExamPeriodId"
                >
                 {allExamPeriod && allExamPeriod.length > 0 ?
                    allExamPeriod.map((eType:any) => <option key={eType.Id} value={eType.ExamName}>{eType.ExamName}</option>)
                  :''}
                </Select> */}
                 <Select placeholder='Exam Subject' width="140px" bg="var(--white-color)" 
              borderColor="var(dark-green-color)" onChange={(e:any)=>handleFilter2(e.target.value)}
                  name="ExamSubjectId"
                >
                  <>{allExamSubject && allExamSubject.length > 0 ?
                    allExamSubject.map((eType:any) => <option key={eType.Id} value={eType.Name}>{eType.Name}</option>)
                  :''}</>
                </Select>
            </Flex>
        
          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">All Subject Score Report</Heading>
            <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
          </Flex>
          {  filter_data && filter_data.length > 0 ?  <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
                <Th sx={HeadStyle}>StudentNo</Th>
                <Th sx={HeadStyle}>First Name</Th>
                <Th sx={HeadStyle}>Middle Name</Th>
                <Th sx={HeadStyle}>Last Name</Th>
                <Th sx={HeadStyle}>Subject</Th>
                <Th sx={HeadStyle}>Exam Period</Th>
                <Th sx={HeadStyle}>Score</Th>
                <Th sx={HeadStyle}>cut-OffMark</Th>
                <Th sx={HeadStyle}>Grade</Th>
                <Th sx={HeadStyle}>Exam Status</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eUpgradeScore:any) =><ROWSTYLE key={eUpgradeScore.Id}>
                <Td sx={DataStyle}>{eUpgradeScore.StudentNo ||'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.FirstName ||'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.MiddleName ||'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.LastName ||'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore?.Subject || 'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore?.ExamPeriod || 'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.Score ||'N/A'}</Td>
                <Td sx={DataStyle}>{typeof eUpgradeScore.CutOffMark === 'number'?eUpgradeScore.CutOffMark:'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.Grade ||'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.ExamStatus||'N/A'}</Td>
                <Td sx={DataStyle} w="50px" h="50px">
                </Td>
              </ROWSTYLE>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          :'No Student Score'  
        }
        <StylePaginateBox>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
          />
  
        </StylePaginateBox>
  
      </Box>
  }
  </>
    )
  }
  const StylePaginateBox = styled.div`
    width:100%;
    & > ul{
      list-style-type: none;
      text-align:center;
      padding:0;
      margin:0;
      margin-top:10px;
    } 
    & > ul > li{
      display: inline;
      margin:0 5px;
      padding:2px 5px;
      border-radius: 3px;
      background-color: transparent;
      color:var(--dark-green-color);
    }
    & > ul > li.selected{
      background-color: var(--highlight-paginate-background);
      color:var(--highlight-paginate-color);
    }
    & > ul > li:first-of-type,
    & > ul > li:last-of-type{
      font-weight: bold;
    }
  `
  
  const sx={
    ':hover':{
      bg:'var(--content-background)'
    }
  }
